// extracted by mini-css-extract-plugin
export default {"header":"ButtonClose_header__R8skv","button":"ButtonClose_button__mQDSu"};